import HomeHero from './home-hero.component'

export default HomeHero
